import React, { useState } from "react";
import { BACKEND_URL } from "../config";
import { Link } from "react-router-dom";


export default function Home() {
  const [audioURL, setAudioURL] = useState(null);
  const [audioFile, setAudioFile] = useState(null);
  const [transcription, setTranscription] = useState("");
  const [match, setMatch] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleUpload = (e) => {
    const file = e.target.files[0];
    setAudioFile(file);
    if (file) {
      setAudioURL(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!audioFile) {
      alert("Please upload an audio file first!");
      return;
    }

    setLoading(true);

    try {
      const formData1 = new FormData();
      formData1.append("file", audioFile);



      const transcribeRes = await fetch(
       `${BACKEND_URL}/transcribe`,
        {
          method: "POST",
          body: formData1,
        }
      );

      const { text } = await transcribeRes.json();
      setTranscription(text);

      const formData2 = new FormData();
      formData2.append("file", audioFile);

      const detectRes = await fetch(
        `${BACKEND_URL}/detect`,
        {
          method: "POST",
          body: formData2,
        }
      );

     const detectData = await detectRes.json();

       if (detectData.error) 
          setMatch(null);
        else setMatch(detectData);
        
 
    } catch (err) {
      console.error(err);
      alert("Upload failed. Is the backend running?");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {/* HERO */}
      <section className="text-center">
        <h1 className="text-3xl font-bold mb-2">
          Detect Any Quran Recitation!
        </h1>
        <p className="text-md mb-4">
          Upload audio and instantly find the matching Surah & Ayah!
        </p>
     

      </section>

      {/* DETECTION */}
      <section className="mx-auto max-w-md rounded bg-teal-400 p-6 dark:bg-teal-700">
        <h2 className="text-2xl font-bold mb-4 text-center">
          🎧 Try QuranDetect
        </h2>

        <form onSubmit={handleSubmit}>
          <input
            type="file"
            accept="audio/wav,audio/mpeg,audio/mp3,audio/mp4,audio/m4a,audio/ogg"
            onChange={handleUpload}
            className="mb-4 w-full"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-teal-600 text-white font-semibold py-2 rounded dark:text-black"
          >
            {loading ? "Processing..." : "Upload & Detect"}
          </button>
        </form>
        {audioURL && (
   <audio
    controls
    className="mt-4 w-full"
    src={audioURL}/>)}
  

           <div className="mt-4 rounded-lg border border-teal-600 bg-teal-200 p-4 dark:border-teal-800 dark:bg-teal-800">
  <h3 className="mb-2 text-sm font-semibold text-black-800">
    Accepted Audio Formats
  </h3>

  <ul className="list-disc pl-5 text-sm text-black-600">
    <ul>.wav (recommended)</ul>
    <ul>.mp3</ul>
    <ul>.m4a</ul>
    <ul>.ogg</ul>
  </ul>

<p className="mt-2 text-xs text-grey-400 text-center"> 
    <strong>Max length:</strong> 60 seconds</p>
  <p className="mt-2 text-xs text-black-800 text-center">
       <strong>Tip:</strong> For best results, upload a single ayah or three with clear recitation and minimal background noise.
</p>
    <p className="mt-2 text-xs text-grey-400 text-center ">
      <strong>Note:</strong> For longer recitations, QuranDetect may return the closest matching ayah rather than the full passage.
</p>
  

</div>

     
{match?.surah && (
  <div className="mt-6 max-w-2xl mx-auto bg-teal-200 rounded-xl shadow p-6 space-y-4 dark:border-teal-800 dark:bg-teal-800">
    {/* Transcription */}
    {transcription && (
      <div className="text-center">
        <h2 className="font-semibold text-lg">🗣️ Transcription</h2>
        <p className="mt-2 text-lg break-words">
          {transcription}
        </p>
      </div>
    )}

    {/* Closest Match */}
    <div className="text-center">
      <h2 className="font-semibold text-lg">📖 Closest Match</h2>

      <p className="text-gray-700 dark:text-black">
       <p> Surah {match.surah} | Ayah {match.ayah} </p>     
</p>
      <p className="text-xl leading-relaxed mt-3">
        {match.arabic}
      </p>

      {match.english && (
        <p className="italic text-purple-600 mt-2 dark:text-blue-700">
          {match.english}
        </p>
      )}

      <p className="text-sm text-gray-700 mt-2 dark:text-black">
        Confidence: {match.confidence.toFixed(2)}%
      </p>
    </div>

  </div>
)}



          

       
        </section>

        {/* FEATURES */}
      <section className="mt-12">
        <h2 className="mb-3 text-xl font-bold text-center">Features</h2>
        <h3 className="text-center mb-3 text-gray-500">Coming Soon</h3>
        <div className="grid grid-cols-2 gap-5 sm:grid-cols-2 md:grid-cols-2">
          <Link to="/radio">
          <div className="rounded bg-teal-300 p-4 dark:bg-teal-700">
            Radio
          </div>
        </Link>
        <Link to="/hifdhgame">
          <div className="rounded bg-teal-300 p-4 dark:bg-teal-700">
             Hifdh Game
           </div>
          </Link>
          </div>       
      </section>
    </>
  );
}
